import { createFileRoute, notFound } from "@tanstack/react-router";
import { gatedRobotsMeta } from "@/lib/seo-gating";
import { TopicHubView } from "@/components/learn/topic/TopicHubView";

export const Route = createFileRoute("/learn/$topic/")({
  // Topic content is fetched when a Learn page opens, not on every visit.
  loader: async ({ params }) => {
    const { getTopic } = await import("@/data/learn/topics");
    const topic = getTopic(params.topic);
    if (!topic) throw notFound();
    return { topic };
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Not found — Recovery Trauma™" }, { name: "robots", content: "noindex" }] };
    }
    const { topic } = loaderData;
    const title = `${topic.title} — Learn — Recovery Trauma™`;
    const url = `https://recoverytrauma.com/learn/${topic.slug}`;
    return {
      meta: [
        { title },
        { name: "description", content: topic.seoDescription },
        { property: "og:title", content: title },
        { property: "og:description", content: topic.seoDescription },
        { property: "og:type", content: "website" },
        { property: "og:url", content: url },
        { name: "twitter:card", content: "summary_large_image" },
        ...gatedRobotsMeta(`/learn/${topic.slug}`),
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: TopicHubPage,
});

function TopicHubPage() {
  const { topic } = Route.useLoaderData();
  return <TopicHubView topic={topic} />;
}
